// React
import { useState } from "react"

// Third-Party Libraries
import toast from "react-hot-toast"
import { useNavigate } from "react-router-dom"

// Types
import type { ErrorFetch, SuccessFetch } from "types"

// Utils
import { useApi } from "utils"

export function useGeneratePo(
  product_id: number,
  qty_order: number
): {
  fetchPo: () => void
  isLoading: boolean
} {
  // Hooks
  const api = useApi()
  const navigate = useNavigate()
  const [isLoading, setLoading] = useState<boolean>(false)

  // Functions
  const fetchPo = (): void => {
    setLoading(true)

    api.get(
      "/requestform/createpo",
      {
        params: {
          qty_order,
          product_id
        }
      }
    ).then((res: SuccessFetch<{
      payload: {
        product: {
          product_id: number
        }
        vendor: {
          vendor_id: number
          vendor_name: string
        }
      }
    }>) => {
      // Vars
      const payload = res.data.payload
      const vendor = payload.vendor

      navigate(`/purchase/transaction/purchase-order`, {
        state: {
          qty_order,
          product_id: payload.product.product_id.toString(),
          vendor_id: vendor.vendor_id.toString(),
          _vendor_name: vendor.vendor_name
        }
      })
    }).catch((err: ErrorFetch<{}>) => {
      toast.error(err.response.message)
    }).finally(() => {
      setLoading(false)
    })
  }

  return { isLoading, fetchPo }
}